<template>
  <div :ref="refChart" class="total-echarts"></div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timecount: new Date().getTime(),
      myChart: null
    }
  },
  computed: {
    refChart() {
      return `total-echarts-${this.timecount}`
    }
  },
  mounted() {
    this.$nextTick(() => {
      let domChart = this.$refs[this.refChart]
      this.myChart = this.$echarts.init(domChart)
      // 绘制图表
      this.myChart.setOption({
        // 标题
        title: {
          // show: true,
          text: `${this.data.name}(合计${this.data.chartList.length || 0}项)`,
          subtext: `${this.data.value}元`,
          textStyle: {
            fontSize: 20
          },
          subtextStyle: {
            color: 'red',
            fontSize: 16
          }
        },
        // 图例
        legend: {
          bottom: '0',
          left: 'center',
          textStyle: {
            lineHeight: 16
          },
          formatter: (name) => {
            let value = this.data.chartList.find((item) => item.name === name).value
            return `${name}\n${value}元` // 标签格式
          }
        },
        // 提示框
        tooltip: {
          trigger: 'item'
        },
        // 数据系列
        series: [
          {
            type: 'pie', // 饼图
            radius: ['50%', '40%'], // 饼图半径
            // 项标签
            label: {
              fontSize: 14,
              // formatter: '{name|{b}}\n{value|{c}元}\n{percent|({d}%)}', // 标签格式
              formatter: '{name|{b}}\n{percent|({d}%)}', // 标签格式
              alignTo: 'edge', // 标签对齐方式
              lineHeight: 18,
              edgeDistance: 10,
              rich: {
                // value: {
                //   color: 'red'
                // },
                percent: {
                  color: 'green'
                }
              }
            },
            data: this.data.chartList.map((item) => ({
              name: item.name,
              value: item.value
            }))
          }
        ]
      })
    })
  }
}
</script>

<style lang="less" scoped>
.total-echarts {
  width: 500px;
  height: 500px;
}
</style>
